import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Cinta de series estilo "AI-OS": un vistazo al sistema editorial completo
// entre el hero y las tarjetas de series. Mismos nombres que HomeSeries.jsx.
const ITEMS = [
  { day: "LUN", name: "Hackea el Tiempo con la IA" },
  { day: "MAR", name: "AI Weekly Recap" },
  { day: "MIÉ", name: "IA para Líderes" },
  { day: "JUE", name: "Casos de Uso · Desde GCP" },
  { day: "VIE", name: "Data en la Era Agéntica" },
  { day: "SÁB", name: "Domina Claude" },
  { day: "DOM", name: "Análisis Trascendental" },
  { day: "FLASH", name: "Fast Post · reacción 4-12h" },
];

export default function SeriesTicker() {
  const { t } = useTranslation();
  // Doble render del contenido para que el loop del marquee sea continuo
  const loop = [...ITEMS, ...ITEMS];

  return (
    <Link
      to="/contenido"
      aria-label={t("home.series.label")}
      style={{
        display: "block",
        borderTop: "1px solid var(--accent-08)",
        borderBottom: "1px solid var(--accent-08)",
        background: "rgba(8,11,20,0.5)",
        padding: "14px 0",
        overflow: "hidden",
        textDecoration: "none",
      }}
    >
      <div className="cb-ticker-track" aria-hidden="true">
        {loop.map((item, i) => (
          <span
            key={i}
            style={{
              fontFamily: "var(--font-body)",
              fontSize: 11.5,
              letterSpacing: "0.13em",
              textTransform: "uppercase",
              color: "var(--text-muted)",
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <span style={{ color: "var(--color-accent)", fontWeight: 700 }}>{item.day}</span>
            {item.name}
            <span aria-hidden="true" style={{ color: "var(--text-ghost)", marginLeft: 28 }}>◆</span>
          </span>
        ))}
      </div>
    </Link>
  );
}
